import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { key: 3 }

import { onMounted, ref, computed } from 'vue';
import { Capacitor } from "@capacitor/core";
import { Clipboard } from '@capacitor/clipboard';
import { getRedeemcodeClaim } from '@/api/giftCode';
import StatusPopup from '@/components/common/statusPopup.vue';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { getActivityInformations } from '@/api/common';
import { Share } from '@capacitor/share';
import GiftCodeViewOne from '@/themes/themeOne/giftCode/giftCodeView.vue';
import GiftCodeViewTwo from '@/themes/themeTwo/giftCode/giftCodeView.vue';
import GiftCodeViewThree from '@/themes/themeThree/giftCode/giftCodeView.vue';
import GiftCodeViewFour from '@/themes/themeFour/giftCode/giftCodeView.vue';
import { GiftCodeData } from './giftCodeView';
import { useThemeStore } from '@/stores/theme';


export default /*@__PURE__*/_defineComponent({
  __name: 'giftCodeView',
  props: {
    isTabView: { type: Boolean }
  },
  setup(__props: any) {

const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const loadingRef = ref()
const themeStore = useThemeStore()

const couponCode = ref('');
const activityInfo = ref([])
const bannerIcon = ref()
const props = __props
const dataSet = computed<GiftCodeData>(() => ({
    activityInfo: activityInfo.value,
    bannerIcon: bannerIcon.value,
    couponCode: couponCode.value
}))

const pasteCode = async () => {
    if (Capacitor.isNativePlatform()) {
        const { type, value } = await Clipboard.read();
        couponCode.value = value;
    } else {
        // For web platform
        navigator.clipboard.readText()
            .then((text) => {
                couponCode.value = text;
            })
            .catch((err) => {
                console.error('Failed to get clipboard data', err);
            });
    }
}
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}
const getActivityInfo = () => {
    loadingRef.value.open();
    let data = {
        activityId: "redeem_code"
    }
    getActivityInformations(data).then(res => {
        loadingRef.value.close();
        bannerIcon.value = res.data?.floatIcon
        activityInfo.value = JSON.parse(res.data?.activityIntro)
    }).catch(err => {
        if (err.code != 401) {
            loadingRef.value.close();
            showError(err);
        }
    })
}
const claimSubmit = (e: any) => {
    loadingRef.value.open()
    let data = {
        claimCode: e
    }
    getRedeemcodeClaim(data).then(res => {
        loadingRef.value.close()
        showSuccess(res?.msg)
    }).catch(err => {
        loadingRef.value.close()
        showError(err);
    })
}
const goToShare = async () => {
    let shareLink = localStorage.getItem('shareLink')

    try {
        if (!shareLink) { return }
        await Share.share({
            text: shareLink,
        });
    } catch (error) {
        console.warn('Not supporting')
    }
}
onMounted(() => {
    getActivityInfo()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(themeStore).themeIndex === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(GiftCodeViewOne, {
            "data-set": dataSet.value,
            onPasteCode: pasteCode,
            onClaimSubmit: claimSubmit,
            onGoToShare: goToShare
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(GiftCodeViewTwo, {
            "data-set": dataSet.value,
            onPasteCode: pasteCode,
            onClaimSubmit: claimSubmit,
            onGoToShare: goToShare
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(GiftCodeViewThree, {
            "data-set": dataSet.value,
            onPasteCode: pasteCode,
            onClaimSubmit: claimSubmit,
            onGoToShare: goToShare,
            "is-tab-view": _ctx.isTabView
          }, null, 8, ["data-set", "is-tab-view"])
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 4)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(GiftCodeViewFour, {
            "data-set": dataSet.value,
            onPasteCode: pasteCode,
            onClaimSubmit: claimSubmit,
            onGoToShare: goToShare,
            "is-tab-view": _ctx.isTabView
          }, null, 8, ["data-set", "is-tab-view"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"]),
    _createVNode(LoadingScreen, {
      ref_key: "loadingRef",
      ref: loadingRef
    }, null, 512)
  ], 64))
}
}

})